/*
  토큰 보관.

  <h2>왜 쿠키가 아닌가</h2>
  내부 앱(front)은 세션 쿠키 + CSRF 토큰을 쓴다. 이 앱은 **`Authorization: Bearer`** 다(DOC-82 §5-2).
  · 세션 쿠키는 `BOMI_SESSION` 하나이고 Domain 이 지정돼 있지 않다(host-only). 서브도메인에서
    쓰겠다고 `Domain=.회사.com` 을 붙이는 순간 **내부 세션이 외부 도메인으로 새어 나간다.**
  · 백엔드의 세션 체인은 `maximumSessions(1)` 이라 내부 로그인과 서로를 밀어낸다.
  · Bearer 로 두면 CSRF 자리가 아예 없어진다.

  대가는 토큰이 JS 에서 읽힌다는 것이고, 그것은 CSP 로 받는다(security-headers.conf.template).

  <h2>왜 localStorage 인가</h2>
  홈 화면에 설치해 쓰는 앱이라(PWA) 탭을 닫았다고 로그아웃되면 못 쓴다. sessionStorage 는
  탭마다 따로라 그 요구와 맞지 않는다.
*/
const ACCESS_KEY = 'bomi.vendor.access';
const REFRESH_KEY = 'bomi.vendor.refresh';

/** 저장소를 못 쓰는 브라우저(사생활 보호 모드 등)에서도 앱이 죽지 않게 한다. */
function safeRead(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  }
  catch {
    return null;
  }
}

function safeWrite(key: string, value: string | null): void {
  try {
    if (value === null) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, value);
  }
  catch {
    // 저장에 실패하면 이번 세션에서만 살아 있는다. 로그인 자체를 막지는 않는다.
  }
}

export function readAccessToken(): string | null {
  return safeRead(ACCESS_KEY);
}

export function readRefreshToken(): string | null {
  return safeRead(REFRESH_KEY);
}

export function storeTokens(accessToken: string, refreshToken: string | null): void {
  safeWrite(ACCESS_KEY, accessToken);
  if (refreshToken !== null) safeWrite(REFRESH_KEY, refreshToken);
}

export function clearTokens(): void {
  safeWrite(ACCESS_KEY, null);
  safeWrite(REFRESH_KEY, null);
}
